module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_6-3582987119ed13e7b29ac1615fe1a066.jpg";